/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LegalAccount } from './LegalAccount';
import {
    LegalAccountFromJSON,
    LegalAccountFromJSONTyped,
    LegalAccountToJSON,
} from './LegalAccount';

/**
 * 
 * @export
 * @interface RegisterLegalAccountOutput
 */
export interface RegisterLegalAccountOutput {
    /**
     * 
     * @type {LegalAccount}
     * @memberof RegisterLegalAccountOutput
     */
    legalAccount?: LegalAccount;
    /**
     * 
     * @type {Error}
     * @memberof RegisterLegalAccountOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the RegisterLegalAccountOutput interface.
 */
export function instanceOfRegisterLegalAccountOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegisterLegalAccountOutputFromJSON(json: any): RegisterLegalAccountOutput {
    return RegisterLegalAccountOutputFromJSONTyped(json, false);
}

export function RegisterLegalAccountOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterLegalAccountOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'legalAccount': !exists(json, 'legalAccount') ? undefined : LegalAccountFromJSON(json['legalAccount']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function RegisterLegalAccountOutputToJSON(value?: RegisterLegalAccountOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'legalAccount': LegalAccountToJSON(value.legalAccount),
        'error': value.error,
    };
}

